// src/lib/kinema/konva/renderers/index.ts
import type { RendererEntry } from './types';
import { ShapeRenderer } from './ShapeRenderer';
import { TextRenderer } from './TextRenderer';
import { ImageRenderer } from './ImageRenderer';
import { VideoRenderer } from './VideoRenderer';
import { CompositionRenderer } from './CompositionRenderer';

export type { KonvaRenderer, RendererEntry } from './types';

export const builtInRenderers: RendererEntry[] = [
  ['shape', ShapeRenderer],
  ['text', TextRenderer],
  ['image', ImageRenderer],
  ['video', VideoRenderer],
  ['composition', CompositionRenderer],
];

export { ShapeRenderer, TextRenderer, ImageRenderer, VideoRenderer, CompositionRenderer };
